import React from "react";
import styled from "styled-components";
import AlertCardAction from "../AlertCardAction";
import { AlertStatus } from "../../utils/alertUtils";
import AlertCardDetail from "../AlertCardDetail";
import { Alert } from "../../types/alert";

type AlertCardProps = {
  alert?: Alert;
  startDate: string;
  endDate?: string;
  status: AlertStatus;
  alertSeriesId: string;
  nbActions?: number;
  deadlineDate?: string;
  dashboardUrl?: string;
  impactFinancier?: number;
  actionPlanSubmitted: () => void;
};

const AlertCardContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: 25rem;
  min-width: 23rem;
  @media (max-width: 768px) {
    min-width: 21rem;
  }
  @media (max-width: 400px) {
    min-width: 19.5rem;
  }
`;

const AlertCard: React.FC<AlertCardProps> = ({
  alert,
  alertSeriesId,
  startDate,
  endDate,
  nbActions,
  status,
  deadlineDate,
  dashboardUrl,
  impactFinancier,
  actionPlanSubmitted,
}) => {
  return (
    <AlertCardContainer>
      <AlertCardDetail
        status={status}
        title={alert ? alert.kpiCode : ""}
        text={alert ? alert.alertingText : ""}
        startDate={startDate}
        endDate={endDate}
        deadlineDate={deadlineDate ? deadlineDate : ""}
        impactFinancier={impactFinancier}
        nbActions={nbActions || 0}
      />
      <AlertCardAction
        alertSeriesId={alertSeriesId}
        status={status}
        dashboardUrl={dashboardUrl}
        deadlineDate={deadlineDate}
        actionPlanSubmitted={actionPlanSubmitted}
      />
    </AlertCardContainer>
  );
};

export default AlertCard;
